module.exports = __webpack_public_path__ + "media/images/e-kvitok/bus-e11c620067cd3bda652272ec027a6894.svg";